var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendedPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 37,
    viewBox: "0 0 15 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1601"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 148",
    d: "M0 0H15V28L7.5 19.7647L0 28V0Z",
    fill: "#9053F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star",
    d: "M10.9594 32.91C10.8299 33.0355 10.7704 33.217 10.7999 33.395L11.2444 35.855C11.2819 36.0635 11.1939 36.2745 11.0194 36.395C10.8484 36.52 10.6209 36.535 10.4344 36.435L8.21994 35.28C8.14294 35.239 8.05744 35.217 7.96994 35.2145H7.83444C7.78744 35.2215 7.74144 35.2365 7.69944 35.2595L5.48444 36.42C5.37494 36.475 5.25094 36.4945 5.12944 36.475C4.83344 36.419 4.63594 36.137 4.68444 35.8395L5.12944 33.3795C5.15894 33.2 5.09944 33.0175 4.96994 32.89L3.16444 31.14C3.01344 30.9935 2.96094 30.7735 3.02994 30.575C3.09694 30.377 3.26794 30.2325 3.47444 30.2L5.95944 29.8395C6.14844 29.82 6.31444 29.705 6.39944 29.535L7.49444 27.29C7.52044 27.24 7.55394 27.194 7.59444 27.155L7.63944 27.12C7.66294 27.094 7.68994 27.0725 7.71994 27.055L7.77444 27.035L7.85944 27H8.06994C8.25794 27.0195 8.42344 27.132 8.50994 27.3L9.61944 29.535C9.69944 29.6985 9.85494 29.812 10.0344 29.8395L12.5194 30.2C12.7294 30.23 12.9049 30.375 12.9744 30.575C13.0399 30.7755 12.9834 30.9955 12.8294 31.14L10.9594 32.91Z",
    fill: "#9053F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendedPlan);
export default __webpack_public_path__ + "static/media/recommendedPlan.185131cedb4fd161769274b310a999d9.svg";
export { ForwardRef as ReactComponent };